import React from 'react';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Container from 'react-bootstrap/Container';
import { ButtonCss, CssTextField} from './Style'
import Typography from '@material-ui/core/Typography';
import Filter from './Filter';

class Header extends React.Component {


  _ConstructFilterArray = (event) => {
    var CurrentRegionArray = [...this.props.Filter]
    var index = CurrentRegionArray.findIndex(res => res === event)
    if (index === -1)
      CurrentRegionArray.push(event)
    else
      CurrentRegionArray.splice(index, 1)
    this.props.refParent.setState({Filter: CurrentRegionArray}, () => {
      this.props.refParent.EventDisplayRegion()
    })
  }

  _createFilter = () => {
    try {
      var Region = ['bxl', 'lux', 'luik', 'anv', 'fl']

      return Region.map((region, index) => {
        return (
          <Filter intl={this.props.intl} region={region} key={index} refParent={this}/>
        )
      })
    } catch (e){
      return <></>
    }
  }

  _applyFilter = () => {
    this.props.refParent.setState({eventDisplay: [], event: [], loadingMore: true}, () => {
      this.props.refParent._getAllNextEvent()
    })
  }

  renderTotal = () => {
    var stringTot = "Total ("
    if (this.props.Event)
      return (stringTot + this.props.Event.length + ')')
    return ("Total (0)")
  }

  render (){
    return (
      <>
      <Container fluid>
        <Row>
          <Col sm={12} xl={12} md={12} lg={12} style={{display: 'flex', justifyContent: 'flex-start', alignItems: 'center'}}>
            <h2 style={{textAlign: 'left', marginBottom: 25}}>Prochains évènements</h2>
          </Col>
        </Row>
      </Container>
      <Container fluid style={{backgroundColor: 'rgba(0, 0, 0, 0.1)',  padding: 20}}>
        <Row style={{marginTop: 10, display: 'flex', justifyContent: 'center'}}>
          {this._createFilter()}
        </Row>

        </Container>
        <Container fluid>
        <Row style={{margin: 10}}>
          <Col sm={12} md={12} lg={12} xl={12} style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
            <div style={{width: "100%", display: 'flex', justifyContent: 'center', alignItems: 'center',}}>
              <CssTextField value={this.props.search ? this.props.search : null} label="Rechercher" variant="outlined" onChange={(event) => this.props.refParent.search(event.target.value)} style={{marginRight: 5}}/>
            </div>
          </Col>
        </Row>
        <Col sm={3} md={3} lg={3} xl={3} style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
          <div style={{width: "100%", display: 'flex', justifyContent: 'flex-start', alignItems: 'center', }}>

              <Typography style={{fontWeight: 'bold', fontSize: '0.98rem', color: '#082430', marginBottom: 50, marginTop: 10}}>{this.renderTotal()}</Typography>

          </div>
        </Col>
        </Container>
        </>
    )
  }
}

/*
<Row>
  <Col sm={12} md={12} lg={12} xl={12} style={{marginTop: 15, display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
    <div style={{width: "25%", display: 'flex', justifyContent: 'center', alignItems: 'center',}}>
      <ButtonCss  onClick={() => this._applyFilter()} color={'inherit'} style={{width: '100%', backgroundColor: 'transparent'}}>
        <Typography style={{fontWeight: 'bold', fontSize: '0.85rem', color: 'black'}}>APPLIQUER LE FILTRE</Typography>
      </ButtonCss>
    </div>
  </Col>
</Row>
*/

export default Header;
